export enum SortOrder {
    Asc = "asc",
    Desc = "desc",
}

export interface SortOptions {
    readonly [column: string]: SortOrder;
}

export interface QueryType {
  type: string;
  body: string;
}

export interface QueryOptions {
    readonly order_by?: SortOptions[];
    readonly results_per_page?: number;
    readonly page_number?: number;
}
